export default __webpack_public_path__ + "static/watching-46e7b28e7ef0ad3feb1d9ceb0d5960ff.svg";